import { StyleSheet } from 'react-native';

import { Theme } from '@constants';

export const styles = StyleSheet.create({
  dailyPageErrorImage: {
    height: Theme.px(201),
    width: Theme.px(307),
  },
  dailyPageErrorText: {
    paddingLeft: Theme.px(87),
    width: Theme.px(525),
  },
  dailyPageErrorWrapper: {
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'center',
    paddingTop: Theme.px(150),
    width: '100%',
  },
  rowWrapper: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  wrapper: {
    paddingTop: Theme.px(61),
  },
});
